import React from 'react';
import { Loader } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import ValidateDataResultsValid from './ValidateDataResultsValid';
import ValidateDataResultsInvalid from './ValidateDataResultsInvalid';
import ValidateDataResultsNotRun from './ValidateDataResultsNotRun';
import ValidateDataResultsPanelContent from './ValidateDataResultsPanelContent';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const ValidateDataResultsPanel = ({ category, code }) => {
  const {
    readStatus, valid, errors, dictionaryCode, dictionaryName, isLoading, isValidating,
  } = Selectors.useValidateDataResultsPanel(category, code);
  const validate = Events.useValidateDictionaryData(category, { code });
  const handleValidate = () => {
    validate({ dictionaryCode });
  };

  if (isValidating) {
    return <Loader active inline="centered" size="large" />;
  }

  if (readStatus === states.SUCCESS) {
    if (valid) {
      return (
        <ValidateDataResultsPanelContent
          valid={valid}
          loading={isLoading}
          dictionaryName={dictionaryName}
          validate={handleValidate}
        >
          <ValidateDataResultsValid />
        </ValidateDataResultsPanelContent>
      );
    }
    if (!valid) {
      return (
        <ValidateDataResultsPanelContent
          valid={valid}
          loading={isLoading}
          dictionaryName={dictionaryName}
          validate={handleValidate}
        >
          <ValidateDataResultsInvalid errors={errors} />
        </ValidateDataResultsPanelContent>
      );
    }
  }

  return (
    <ValidateDataResultsPanelContent
      valid={valid}
      loading={isLoading}
      dictionaryName={dictionaryName}
      validate={handleValidate}
    >
      <ValidateDataResultsNotRun />
    </ValidateDataResultsPanelContent>
  );
};

export default ValidateDataResultsPanel;
